import { render, staticRenderFns } from "./CyberbizCustomerLevelChange.vue?vue&type=template&id=38680aca&scoped=true&"
import script from "./CyberbizCustomerLevelChange.vue?vue&type=script&lang=js&"
export * from "./CyberbizCustomerLevelChange.vue?vue&type=script&lang=js&"
import style0 from "./CyberbizCustomerLevelChange.vue?vue&type=style&index=0&id=38680aca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38680aca",
  null
  
)

export default component.exports